module.exports = __webpack_public_path__ + "img/drug_card_layout__separate__en.885b2e2c.png";